var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossLightCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.211 12.246 14.966 16l-3.755 3.753a.737.737 0 0 0 0 1.033.745.745 0 0 0 1.039.006l3.754-3.754 3.75 3.748c.278.278.748.284 1.032 0s.284-.76.006-1.038L17.043 16l3.749-3.748a.744.744 0 0 0-.006-1.038.737.737 0 0 0-1.033 0l-3.749 3.747-3.754-3.753a.745.745 0 0 0-1.039.006.737.737 0 0 0 0 1.032z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 25.177c5.01 0 9.177-4.176 9.177-9.177 0-5.008-4.175-9.177-9.188-9.177-4.999 0-9.166 4.165-9.166 9.177 0 5 4.177 9.177 9.177 9.177zM27 16c0 6.007-4.982 11-11 11-6.007 0-11-4.993-11-11C5 9.982 9.982 5 15.99 5 22.006 5 27 9.982 27 16z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossLightCircle);
export default __webpack_public_path__ + "static/media/Cross-Light_Circle.55f7f7c783bb3c3901d8d418df62f965.svg";
export { ForwardRef as ReactComponent };